<template>
  <div>
    <div class="h-132 flex flex-col relative gap-8 p-9 mx-2 my-4 mb-0 border-l border-dashed box-sizing-border">
      <svg class="w-3 h-7 absolute top-5 left-0">
        <use xlink:href="/images/svg-symbols.svg#half-scissors"></use>
      </svg>

      <h2 class="mt-7 text-subtitle">Comprovante de postagem Jadlog</h2>

      <ul class="flex flex-col gap-8">
        <li v-for="(step, index) in steps" class="flex items-center gap-4">
          <span class="w-8 h-8 flex flex-0 items-center justify-center border-2 border-black rounded-full text-highlight">
            {{ index + 1 }}
          </span>

          <p class="text-small">{{ step }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      steps: [
        'Confira seu comprovante de postagem na última folha antes de imprimir.',
        'Recorte o comprovante de postagem no local indicado.',
        'Lembre-se: o comprovante é um documento criado para a segurança de sua encomenda.',
      ],
    }
  },
}
</script>